import ThreeDotMenu from './ThreeDotMenu';

export default ThreeDotMenu;
